import getEnv from 'tanggram';

const conf = getEnv();

function getS3ImagePath(subPath) {
  return `${conf.assets.s3Image.basePath}${subPath ? subPath : ''}`;
}

export default getS3ImagePath;